import React from 'react'

import { Field } from 'formik'

import { Form } from '_zari/core'

const FlagEnvioAutomaticoFormGroup = ({ iValue, fIsSubmitting }) => {
  return (
    <Field name='flagEnvioAutomatico'>
      {({ field }) => (
        <Form.Checkbox
          {...field}
          checked={iValue}
          disabled={fIsSubmitting}
          id='checkbox-flagEnvioAutomatico'
          label='Envio automatico de documentos'
        />
      )}
    </Field>
  )
}

export default React.memo(FlagEnvioAutomaticoFormGroup)
